import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import themes from '@/js/modules/themes'

Vue.use(Vuetify)

const theme = themes[Math.floor(Math.random() * themes.length)]

const opts = {
	theme: {
    themes: {
      light: {
        primary: localStorage.theme ? JSON.parse(localStorage.theme).primary : theme.primary,
				secondary: localStorage.theme ? JSON.parse(localStorage.theme).secondary : theme.secondary,
				accent: localStorage.theme ? JSON.parse(localStorage.theme).accent : theme.accent,
				info: localStorage.theme ? JSON.parse(localStorage.theme).info : theme.info,
				error: localStorage.theme ? JSON.parse(localStorage.theme).error : theme.error,
      },
    },
  },
}

export default new Vuetify(opts)
